const getDefaultState = () => {
    return {
        primaryColor: "#1398b5",
        titlesColor: "#000000",
        fieldsColor: "#787d8f",
        backGroundColor: "rgba(245, 245, 245, 1)",
        fontFamily: "Roboto, sans-serif",
        txtIntroCmaj: null,
        formTittleCmaj: null,
        currentStep: 1,
        availableFonts: [
            "Arial, sans-serif",
            "Courier New, monospace",
            "Garamond, serif",
            "Georgia, serif",
            "Helvetica, sans-serif",
            "Roboto, sans-serif",
            "Segoe UI",
            "Tahoma, sans-serif",
            "Times New Roman, serif",
            "Trebuchet MS, sans-serif",
            "Verdana, sans-serif",
        ],
        caspPrimaryColor: "#1398b5",
        caspTitlesColor: "#000000",
        caspFieldsColor: "#787d8f",
        caspBackGroundColor: "rgba(245, 245, 245, 1)",
        caspFontFamily: "Roboto, sans-serif",
        txtIntroCasp: null,
        cadhPrimaryColor: "#1398b5",
        cadhTitlesColor: "#000000",
        cadhFieldsColor: "#787d8f",
        cadhBackGroundColor: "rgba(245, 245, 245, 1)",
        cadhFontFamily: "Roboto, sans-serif",
    }
}

const webFormStyle = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setFontFamily(state, value) {
            state.fontFamily = value
        },
        setPrimaryColor(state, value) {
            state.primaryColor = value
        },
        setTitlesColor(state, value) {
            state.titlesColor = value
        },
        setFieldsColor(state, value) {
            state.fieldsColor = value
        },
        setBackGroundColor(state, value) {
            state.backGroundColor = value
        },
        setCurrentStep(state, value) {
            state.currentStep = value
        },
        setTxtIntroCmaj(state, value) {
            state.txtIntroCmaj = value
        },
        setFormTittleCmaj(state, value) {
            state.formTittleCmaj = value
        },
        setCaspFontFamily(state, value) {
            state.caspFontFamily = value
        },
        setCaspPrimaryColor(state, value) {
            state.caspPrimaryColor = value
        },
        setCaspTitlesColor(state, value) {
            state.caspTitlesColor = value
        },
        setCaspFieldsColor(state, value) {
            state.caspFieldsColor = value
        },
        setCaspBackGroundColor(state, value) {
            state.caspBackGroundColor = value
        },
        setCadhFontFamily(state, value) {
            state.cadhFontFamily = value
        },
        setCadhPrimaryColor(state, value) {
            state.cadhPrimaryColor = value
        },
        setCadhTitlesColor(state, value) {
            state.cadhTitlesColor = value
        },
        setCadhFieldsColor(state, value) {
            state.cadhFieldsColor = value
        },
        setCadhBackGroundColor(state, value) {
            state.cadhBackGroundColor = value
        },
        setTxtIntroCasp(state, value) {
            state.txtIntroCasp = value
        },
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
    },
}

export default webFormStyle